export class NoCodesConfig {
    constructor(projectKey, noCodesListener = undefined, purchaseDelegate = undefined, proxyUrl = undefined, locale = undefined, theme = undefined) {
        this.projectKey = projectKey;
        this.noCodesListener = noCodesListener;
        this.purchaseDelegate = purchaseDelegate;
        this.proxyUrl = proxyUrl;
        this.locale = locale;
        this.theme = theme;
    }
}
//# sourceMappingURL=NoCodesConfig.js.map